module.exports = __webpack_public_path__ + "static/kartchen-info-allgemein3-51771e90337c45de38ba6e0f773b0452.png";